// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"21f7ad46","140":"d1962e28","292":"5df4f552","453":"e13da595","560":"04dbc590","680":"17e21a43","721":"bcca19a5"}[chunkId] + ".chunk.js";
};